<template>
  <div>
    <h6>待補藥清單</h6>
    <vuetable ref="vuetable"
    :api-url="`${server}/api/refill-order/?drug_storage__device__net__system__type=Tag`"
    data-path=""
    pagination-path=""
    :fields="fields"
    :api-mode="true"
    :css="boostrapCss"
    :http-options="httpOptions"
    @vuetable:cell-clicked="onCellClicked">
      <template slot="num-refill" slot-scope="props">
        <span style="color: red">{{ props.rowData.drug_storage.max_stock - props.rowData.drug_storage.stock}}</span>
      </template>
      <template slot="action" slot-scope="props">
        <button class="btn btn-danger" @click="deleteOrder(props.rowData.id)">刪除</button>
      </template>
    </vuetable>
  </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import { mapState } from 'vuex';
import Vuetable from 'vuetable-2/src/components/Vuetable';
import readCookie from '@/vuex/functions/readCookie';
import server from '@/config';


export default {
  name: 'TagPlanningList',
  data() {
    return {
      boostrapCss: {
        tableClass: 'table table-striped table-bordered table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: '',
          },
        },
      },
      httpOptions: {
        headers: {
          Authorization: `Token ${readCookie('Token')}`,
        },
      },
      server,
      fields: [
        {
          name: 'drug_storage.device.id',
          title: '位置',
        },
        {
          name: 'drug_storage.medication.generic_name',
          title: '藥物',
        },
        {
          name: 'drug_storage.stock',
          title: '目前存量',
        },
        {
          name: 'drug_storage.max_stock',
          title: '最大存量',
        },
        {
          name: '__slot:num-refill',
          title: '待補數量',
        },
        {
          name: '__slot:action',
          title: '動作',
        },
      ],
    };
  },
  components: {
    Vuetable,
  },
  methods: {
    onCellClicked(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.id);
    },
    setRefill() {
      const promises = [];
      const selected = this.$refs.vuetable.selectedTo;
      selected.forEach((drugStorageId) => {
        promises.push(this.instance.post('/api/refill-order/', {
          drug_storage_id: drugStorageId,
        }));
      });

      axios.all(promises)
      .then((res) => {
        console.log(res);
      });
    },
    deleteOrder(id) {
      this.instance.delete(`/api/refill-order/${id}/`)
      .then((res) => {
        this.$refs.vuetable.refresh();
        this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '刪除成功',
        });
      });
    },
  },
  computed: mapState({
    systems: state => state.systems,
    instance: state => state.instance,
  }),
};
</script>




// WEBPACK FOOTER //
// PlanningList.vue?7505defe